import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  TYPE_STUDIO,
  TYPE_PREP,
  TYPE_SET,
  TYPE_RETOUCH,
  TYPE_MERCHANDISE_COORDINATION,
  TYPE_PLANNING_PRODUCING,
  TYPE_COPY,
  TYPE_COPY_PREP,
  TYPE_TRANSLATION_CHINESE,
  TYPE_TRANSLATION_FRENCH,
  TYPE_TRANSLATION_JAPANESE,
  TYPE_ACC_PREP,
  TYPE_INVENTORY_PREP,
  TYPE_ASSISTANT_TEAM,
  TYPE_POIRIER_SET
} from '../../constants/booking';
import StudioSheet from './LocationSheets/StudioSheet';
import StylingRoomSheet from './LocationSheets/StylingRoomSheet';
import AccessoriesSheet from './LocationSheets/AccessoriesSheet';
import MerchandiseSheet from './LocationSheets/MerchandiseSheet';
import PlanningSheet from './LocationSheets/PlanningSheet';
import { renderSheets } from './CallsheetUtils';
import AccessoriesPrepSheet from './LocationSheets/AccessoriesPrepSheet';
import CallsheetHeader from './CallsheetHeader';
import GeneralLocationSheet from './LocationSheets/GeneralLocationSheet';
import { naturalSortKeys } from '../../helpers/callSheetHelpers';

import i18n from '../../i18n';

class ManagementCallsheet extends Component {
  render() {
    const { bookings, date, renderForEmail, locationContacts } = this.props;

    let locationSheets = [];

    Object.entries(bookings).forEach(locationTypeEntry => {
      const [locationTypeIdString, locations] = locationTypeEntry;
      const locationTypeId = parseInt(locationTypeIdString, 10);

      const filteredLocationContacts = locationContacts ? locationContacts[locationTypeId] : i18n.t('noData');
      switch (locationTypeId) {
        case TYPE_STUDIO:
          locationSheets = locationSheets.concat(
            renderSheets(
              StudioSheet,
              locations,
              renderForEmail,
              locationContacts
            )
          );
          break;
        case TYPE_PREP:
          locationSheets = locationSheets.concat(
            renderSheets(
              StylingRoomSheet,
              locations,
              renderForEmail,
              locationContacts
            )
          );
          break;
        case TYPE_SET:
          locationSheets = locationSheets.concat(
            renderSheets(
              AccessoriesSheet,
              locations,
              renderForEmail,
              locationContacts
            )
          );
          break;
        case TYPE_COPY:
        case TYPE_COPY_PREP:
        case TYPE_TRANSLATION_CHINESE:
        case TYPE_TRANSLATION_FRENCH:
        case TYPE_TRANSLATION_JAPANESE:
        case TYPE_RETOUCH:
        case TYPE_ASSISTANT_TEAM:
        case TYPE_INVENTORY_PREP:
        case TYPE_POIRIER_SET:
          locationSheets = locationSheets.concat(
            renderSheets(GeneralLocationSheet, locations, renderForEmail, filteredLocationContacts)
          );
          break;
        case TYPE_MERCHANDISE_COORDINATION:
          locationSheets = locationSheets.concat(
            renderSheets(MerchandiseSheet, locations, renderForEmail, null)
          );
          break;
        case TYPE_PLANNING_PRODUCING:
          locationSheets = locationSheets.concat(
            renderSheets(PlanningSheet, locations, renderForEmail, null)
          );
          break;
        case TYPE_ACC_PREP:
          locationSheets = locationSheets.concat(
            renderSheets(
              AccessoriesPrepSheet,
              locations,
              renderForEmail,
              locationContacts
            )
          );
          break;
        default:
          // There shouldn't be any uncovered location types for management
          console.error('Unrecognized location type in Management Callsheet');
          break;
      }
    });

    return (
      <>
        <CallsheetHeader date={date} renderForEmail={renderForEmail} />
        {locationSheets.sort(naturalSortKeys)}
      </>
    );
  }
}

ManagementCallsheet.propTypes = {
  bookings: PropTypes.objectOf(PropTypes.objectOf(PropTypes.object)).isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  renderForEmail: PropTypes.bool.isRequired,
  locationContacts: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.array])
  ).isRequired
};

export default ManagementCallsheet;
